/**
 * Columns for the alerts inside one change event.
 *
 * Server-paged, so no client-side `sorter` here either.
 */
const EventAlertsColumn = [
  {
    title: 'No.',
    dataIndex: 'index',
    width: 70
  },
  {
    title: 'Alert ID',
    dataIndex: 'alertId',
    slot: 'alertId',
    width: 110
  },
  {
    // The page title on the first line, its address underneath. A customer must
    // never be shown a bare page id.
    title: 'Webpage',
    dataIndex: 'webpageName',
    slot: 'webpage',
    width: 340
  },
  {
    title: 'Detected',
    dataIndex: 'detectedAt',
    slot: 'detectedAt',
    width: 140
  },
  {
    title: 'Severity',
    dataIndex: 'severity',
    slot: 'severity',
    width: 110
  },
  {
    // The legend under the table gives the one-line meaning of each name.
    // "How sure" was dropped: it read 100% on nearly every row, because the
    // rule that matches most alerts always scores 1.00. The score is still on
    // the member row in the API, for debugging.
    title: 'Why Grouped',
    dataIndex: 'joinRuleLabel',
    slotTitle: 'joinRuleTitle',
    width: 220
  }
];

export { EventAlertsColumn };
